import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = { hasError: false };

  public static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
    window.location.reload();
  }

  public render() {
    if (this.state.hasError) {
      // reload()가 실행되는 동안 빈 화면 대신 배경색만 보여줌
      return <div style={{ minHeight: '100vh', background: '#f9f7f4' }} />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
